import React, {useState, useMemo} from 'react';
import { Link } from 'react-router-dom';
import './estimator.css';

const PACKAGE_PRICES = { Basic: 24.9, Premium: 34.9, VIP: 49.9 };

export default function Estimator(){
  const [guests, setGuests] = useState(50);
  const [pkg, setPkg] = useState('Premium');
  const [extras, setExtras] = useState({drinks:false, desserts:false, staff:false});

  const total = useMemo(()=>{
    const base = PACKAGE_PRICES[pkg] || PACKAGE_PRICES.Premium;
    let per = base;
    if(extras.drinks) per += 4.5;
    if(extras.desserts) per += 3.5;
    if(extras.staff) per += 2.5; // extra staffing cost per person (estimate)
    const people = Math.max(1, Number(guests) || 0);
    return {per: per.toFixed(2), total: (per * people).toFixed(2)};
  },[guests,pkg,extras]);

  function toggleExtra(name){
    setExtras(e=>({...e,[name]:!e[name]}));
  }

  return (
    <div className="estimator">
      <h3>Live-Preisrechner</h3>
      <div className="est-row">
        <label>Personen</label>
        <input type="number" min="1" value={guests} onChange={e=>setGuests(e.target.value)} />
      </div>

      <div className="est-row">
        <label>Paket</label>
        <div className="btn-group">
          {Object.keys(PACKAGE_PRICES).map(p => (
            <button key={p} className={p===pkg? 'active':''} onClick={()=>setPkg(p)}>{p}</button>
          ))}
        </div>
      </div>

      <div className="est-row">
        <label>Extras</label>
        <div className="extras">
          <label><input type="checkbox" checked={extras.drinks} onChange={()=>toggleExtra('drinks')} /> Getränke (+€4.50 p.P.)</label>
          <label><input type="checkbox" checked={extras.desserts} onChange={()=>toggleExtra('desserts')} /> Dessert (+€3.50 p.P.)</label>
          <label><input type="checkbox" checked={extras.staff} onChange={()=>toggleExtra('staff')} /> Zusätzl. Personal (+€2.50 p.P.)</label>
        </div>
      </div>

      <div className="est-result">
        <div>
          <small>Preis pro Person</small>
          <strong>€{total.per}</strong>
        </div>
        <div>
          <small>Geschätzter Gesamtpreis</small>
          <strong>€{total.total}</strong>
        </div>
      </div>

      <div className="est-actions">
        <Link className="btn" to="/kontakt">Angebot anfragen</Link>
      </div>
    </div>
  );
}
